import React from "react";

export default function UploadErrorSummary({ files }) {
  const failedCount =
    files?.filter((file) => file.isValid === false).length ?? 0;
  if (failedCount === 0) return null;

  return (
    <div
      role="alert"
      className="sticky top-0 z-10 flex items-start gap-[10px] mt-[8px] px-[12px] py-[10px] bg-[#FBF2F2] border-[1px] border-primaryRed text-[#9F3A37] text-standardSmall leading-[20px]"
    >
      <img className="content-infoIcon w-[20px] h-[20px] shrink-0" alt="" />
      <p>
        <span className="font-latoBold">
          {failedCount === 1
            ? "1 fil kunne ikke behandles"
            : `${failedCount} filer kunne ikke behandles`}
        </span>{" "}
        og kan derfor ikke trækkes over i din ekstrakt. Se forklaringen ved
        filen, og upload en ny version.
      </p>
    </div>
  );
}
